<template>
    <TransitionRoot appear :show="qrcreate.modal_style" as="template">
        <Dialog as="div" class="relative z-50">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-30" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="editor-modal-qr relative transform overflow-hidden rounded-md bg-white text-left align-middle shadow-xl transition-all">
                            <DialogTitle as="div"
                                class="relative z-[99] flex items-center justify-center px-4 py-2 border-b border-b-gray-200">
                                <h3 class="text-lg lg:text-xl font-medium leading-6 text-gray-900 xs:block hidden"> QR Code Style Editor</h3>
                                <div class="ml-auto flex items-center gap-2">
                                    <button v-if="qrcreate.select_template.id" @click="ClearStyle()"
                                        class=" text-center cursor-pointer rounded flex justify-center items-center flex-shrink-0 p-2 font-semibold box-border align-middle text-danger">
                                        Clear Style
                                    </button>
                                    <button @click="qrcreate.modal_style = false"
                                        class="  text-center cursor-pointer rounded flex justify-center items-center flex-shrink-0 py-2  px-4 bg-gray-200 font-semibold appearance-none box-border align-middle  text-black">
                                        <XIcon size="18" /> <span>Close</span>
                                    </button>
                                </div>
                            </DialogTitle>
                            <div class="relative lg:ml-[500px] sm:ml-20 ml-16 rounded-bl-xl h-full bg-gray-200">
                                <div class="flex items-center justify-center w-full h-full">
                                    <QrcreateCanvasQr />
                                </div>
                            </div>
                            <div class="absolute left-0 top-0 pt-[65px] w-fit flex h-full bg-white rounded-bl-xl z-50 "
                                :class="{ 'sm:!w-20 !w-16': !visible }">
                                <div class="sm:w-20 w-16 h-full border-r border-gray-200 flex-shrink-0">
                                    <QrcreateTabMenu @selectTab="selectTab" :tabActive="qrcreate.tab_active" />
                                </div>
                                <div class="lg:w-[420px] xs:w-[380px] w-full h-full overflow-y-auto" :class="{ 'hidden': qrcreate.tab_active == '' }">
                                    <QrcreateSfQrCode v-if="qrcreate.tab_active == 'QR Code'" />
                                    <QrcreateLogoSetting v-if="qrcreate.tab_active == 'LOGO'" />
                                    <QrcreatePublicStyle v-if="qrcreate.tab_active == 'Public Style'" />
                                    <QrcreateEditStyle v-if="qrcreate.tab_active == 'Edit Style'" />
                                    <div class=""></div>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup lang="ts">
import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
} from '@headlessui/vue'
import { XIcon } from "vue-tabler-icons"
import { useQrCreateStore } from '~~/stores/qrcreate';
const qrcreate = useQrCreateStore()

const qrstyle = useQrStyle()
const visible = ref(true)
const device = useDevice()

const selectTab = (tab: string) => {
    if (device.isDesktopOrTablet) {
        if (tab == qrcreate.tab_active) {
            qrcreate.tab_active = ''
        } else {
            qrcreate.tab_active = tab
        }
    } else {
        qrcreate.tab_active = tab
    }
    
}
const ClearStyle = () => {
    qrcreate.select_template = {}
    qrstyle.GenerateQrCode({ stack: false })
    qrcreate.fields = {}
}
</script>
<style lang="scss">
.editor-modal-qr {
    width: calc(100% - 80px) !important;
    height: calc(100vh - 48px) !important;
    padding-bottom: 0;
}
@media (max-width:480px) {
    .editor-modal-qr{
        width: calc(100% - 20px) !important;
    }
}
</style>
